export enum ChangeSummary {
    NEW = 'NEW  Feature', 
    MODIFICATION = 'Modification',
    DELETION = 'Deleted Change'
}